/**
 * Centralized URL Configuration
 * Single source of truth for all application URLs
 */

// URL Configuration Object
export const urlConfig = {
  // Environment detection
  isProduction: import.meta.env.PROD,
  isDevelopment: import.meta.env.DEV,
  
  // API Configuration - Used by all services for backend communication
  api: {
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001'
  },

  // App URLs - Used for SEO meta tags and canonical URLs
  app: {
    baseURL: import.meta.env.VITE_APP_BASE_URL || 'http://localhost:5173',
    productionURL: import.meta.env.VITE_PRODUCTION_URL || 'https://andlegur.com',
    
    // Get the appropriate base URL based on environment
    get currentBaseURL() {
      return urlConfig.isProduction ? this.productionURL : this.baseURL;
    },

    // Page URLs for SEO meta tags
    get pages() {
      const base = this.currentBaseURL;
      return {
        home: `${base}/`,
        about: `${base}/about`,
        community: `${base}/community`
      };
    }
  },

  // App store download links
  stores: {
    ios: 'https://apps.apple.com/us/app/andlegur/id6759088599',
    android: 'https://play.google.com/store/apps/details?id=com.andlegur.mobile'
  },

  // External URLs for social media and tracking
  external: {
    social: {
      twitter: 'https://x.com/andlegur',
      instagram: 'https://www.instagram.com/andlegur1/',
      youtube: 'https://www.youtube.com/@Andlegur',
      facebook: 'https://www.facebook.com/profile.php?id=61563751566301'
    }
  },

  // Asset URLs for SEO images
  assets: {
    logo: `${import.meta.env.VITE_APP_BASE_URL || 'http://localhost:5173'}/site-icon-512.png`,
    // Use production URL for OG images to ensure they work in all contexts
    get ogImage() {
      return urlConfig.isProduction 
        ? 'https://andlegur.com/og-image.png'
        : `${import.meta.env.VITE_APP_BASE_URL || 'http://localhost:5173'}/og-image.png`;
    }
  },

  // Supabase Storage URLs for app downloads
  storage: {
    baseURL: import.meta.env.VITE_SUPABASE_URL,
    bucket: 'app-downloads',
    
    get downloads() {
      const base = `${this.baseURL}/storage/v1/object/public/${this.bucket}`;
      return {
        ios: `${base}/ios/andlegur-v1.0.0.ipa`,
        android: `${base}/android/andlegur-v1.0.0.apk`
      };
    }
  }
};

// Export for backward compatibility
export default urlConfig;